/* eslint-disable */
// This file is automatically generated and should not be edited directly.
// Please edit the corresponding SVG file

import React from 'react';

const DkFlag = (props: any) => (
<svg {...props} xmlns="http://www.w3.org/2000/svg"   viewBox="0 0 18 18" fill="none" stroke="none">
	<mask id="mask0_2620_761754" style={{"maskType":"alpha"}} maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
		<circle cx="9" cy="9" r="9" fill="#C4C4C4"/>
	</mask>
	<g mask="url(#mask0_2620_761754)">
		<rect x="-1.47412" width="25.2006" height="18.0005" rx="1.71429" fill="white"/>
		<mask id="mask1_2620_761754" style={{"maskType":"luminance"}} maskUnits="userSpaceOnUse" x="-2" y="0" width="26" height="19">
			<rect x="-1.22412" y="0.25" width="24.7006" height="17.5005" rx="1.46429" fill="white" stroke="white" strokeWidth="0.5"/>
		</mask>
		<g mask="url(#mask1_2620_761754)">
			<path fillRule="evenodd" clipRule="evenodd" d="M0.239432 0C-0.707342 0 -1.47485 0.767508 -1.47485 1.71428V7.20018H5.72533V0H0.239432ZM9.32542 0V7.20018H23.7258V1.71429C23.7258 0.767512 22.9583 0 22.0115 0H9.32542ZM23.7258 10.8003H9.32542V18.0005H22.0115C22.9583 18.0005 23.7258 17.233 23.7258 16.2862V10.8003ZM5.72533 18.0005V10.8003H-1.47485V16.2862C-1.47485 17.2329 -0.707342 18.0005 0.239432 18.0005H5.72533Z" fill="#EF264D"/>
		</g>
	</g>
	<circle cx="9" cy="9" r="8.5" stroke="white"/>
</svg>
);

export default DkFlag;